import { NetworkCoverageSummarySchema } from '@sweetistics/contracts';
import type { z } from 'zod';

export type NetworkCoverageSummaryInput = z.input<typeof NetworkCoverageSummarySchema>;
export type NetworkCoverageSummaryOutput = z.output<typeof NetworkCoverageSummarySchema>;

export function serializeNetworkCoverageSummary(payload: NetworkCoverageSummaryInput): NetworkCoverageSummaryOutput {
  return NetworkCoverageSummarySchema.parse(payload);
}
